import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import Table from '../../../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Box, Typography, styled } from '@mui/material';
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../../Functions/Traitement/ReformatDate';
import Datas from "../../../../../Data/Data.json"
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import { DemandeQardDto } from '../../../../../Models/DemandeQardDto';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import ParamsQard from '../../../../../Models/ParamsQard';
import { PrintTabamortdemande } from '../../../../../utilitaires/PrintTabAmortDemande';
import { useAgence } from '../../../../../AgenceContext';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';
//import "../../Assets/Styles/StyleForm.css";


const  Contratfinancement = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [sbmit, setSbmit] = useState("")
  const [data, setData] = useState<DemandeQardDto[]>([])
  const navigate = useNavigate()
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [radioaCheck, setRadioaCheck] = useState(false);
  const [garantiesTableau, setGarantiesTableau] = useState<DataTypeTable[]>([]);
  const [datatabamort, setdatatabamort] = useState([]);
  const Branch=useAgence();
  const [documents, setDocuments] = useState<any[]>([]);
  

  const loadFinancement=()=>
      {
         localStorage.clear()
        setPageLoad(false)
        setLoading(true)
        setData([])
    
        let searchClientComptes: ParamsPicklist = { CodeAgence: user.codage, Table: "DEMAND_FINQARD", Colonne1: "EtapeActuelle", Colonne2: "", Init: "CONTRAT", Colagence: 'CODAGE', Choix: 34 }
    
        var config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Datas.ApiUrl.AnySearch,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader(),
            'CypherSearch': Crypter.encrypt(JSON.stringify(searchClientComptes))
          }
        };
        axios(config)
          .then((response) => {
            //alert('ok')
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
    
              if (res.StatutCode == 200) 
              {
                let datas = res.Result.Table;
                 //alert(JSON.stringify(datas))
    
                //alert(datas.length)
                if (datas.length === 0) {
                  SweetAlert.fire({ title: "Aucune demande de prêt en cour", icon: "warning" })
                }
                else {
                
                    var newData: DemandeQardDto[] = [];
                           
                      datas.map((data: any, indice: number) => {
                        newData.push({
                          ...data,
                          key: indice,
                          NumeroDemande: data.NumeroDemande,
                          CODAGE: data.CODAGE,
                          Numcli: data.NUMCLI,
                          NOMCLI: data.NOMCLI,
                          DateDemande : data.DateDemande ? (new Date(data.DateDemande.substring(0, 10))).toLocaleDateString("fr") : '',
                          CodeQard:data.CodeQard,
                          MontantDemande:data.MontantDemande,
                          CODGEA:data.CODGEA,
                          MontantValide:formatNumber(data.MontantValide),

                        })});
                  setData(newData);
               }
              }
            } else {
              alert(JSON.stringify(response))
            }
    
            setLoading(false)
          }).catch((error) => {
            setLoading(false)
            SweetAlert.fire({ title: "Error", text: error, icon: "error" })
          })
    
      }

  if (pageLoad) 
  {
    loadFinancement();
  }



  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }


  function handleAnulle() {
    setRadioaCheck(false)
    setImpActive(true)
    //setData([])
     setSelectedRowKeys([])
    form.resetFields()
    // localStorage.clear()
    initialiazeButton()
   
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)
  }

  function modifButton() {
    setRadioaCheck(true)
    setSbmit("add")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
  }


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Détail  du financement
        </span>
      ),
      children: <Tab1 form={form} />,
    },
    {
      key: '3',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Document
        </span>
      ),
      children: <Tab2 form={form} />,
    },
    {
      key: '5',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Tableau d'amortissement
        </span>
      ),
      children: <Tab3 form={form}  data={datatabamort}/>,
    }
  ];

  const onFinish = () => 
  {
     let values=form.getFieldsValue();
    
     var DemandeQard: DemandeQardDto = {
            CODAGE: user.codage,
            DatePremEch: formatDate(values.DatePremEch),
            // DateDemande: user.datjour,
            Numcli:values.NUMCLI,
            NOMCLI: values.lib_NUMCLI,
            ...values,
          };

        DemandeQard.Documents = values.Document || [];
    
       if(sbmit=="Apercu")
        {
            PrintTabamortdemande(
                    user.coduti ?? '',
                    user.codage ?? '',
                    Branch.agence?.LIBELLE ?? '',
                    Branch.agence?.BANQUE ?? '',
                    Branch.agence?.TELEPH ?? '',
                    Branch.agence?.NUMREG ?? '',
                    Branch.agence?.LICENCE ?? '',
                    Branch.agence?.NUMREG ?? '',
                    Branch.agence?.BPOSTE ?? '',
                    Branch.agence?.VILLE ?? '',
                    user.nomuti ?? '',
                    values.lib_Periodicite,
                  DemandeQard,                           
            );
    
           setSbmit("add");
                 
       } 
      else if (sbmit === 'add') 
      {
     
        SweetAlert.fire({
                title: 'Voulez-vous enregistrer le contrat de financment Qard de type '+
                  values.lib_CodeQard +  '\n du client : ' + values.lib_NUMCLI +'\n à hauteur du montant : ' +
                  formatNumber(values.MontantValide) +' XAF ?',
                showCancelButton: true,
                color: 'green',
                confirmButtonText: 'Yes',
                confirmButtonColor: 'green',
                cancelButtonColor: 'darkred',
                cancelButtonText: 'No',
                showLoaderOnConfirm: true,
                icon: 'question',
        }).then((res) =>{
          if (res.isConfirmed) 
          {
             
            try {
                      setLoading(true);
                      setIsSubmit(true);
                        DemandeQard.UtilContrat=user.coduti;
                        DemandeQard.CodeUti=user.coduti;
                        DemandeQard.DateContrat= user.datjour;
                      let data = Crypter.encrypt(JSON.stringify(DemandeQard));
        
                      let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.Contrat,
                        headers: {
                          Authorization: authHeader(),
                          'Content-Type': 'application/json',
                        },
                        data: data,
                      };
            
                  axios
                    .request(config)
                    .then((response) => {
                      setLoading(false);
                      if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
    
                      if (res.StatutCode == 200) {
                        initialiazeButton();
                        form.resetFields();
                        // ✅ Vider le tableau après enregistrement réussi
                        setGarantiesTableau([]);
                        setdatatabamort([]);
                        setImpActive(false);
                        loadFinancement();
                        SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'success' });
                      } else SweetAlert.fire({ title: res.Message, text: res.Result, icon: 'warning' });
                           
                    }             
                })                          
                .catch((error) => 
                  {
                        setLoading(false);
                        console.log(error);
                        SweetAlert.fire({ title: error, icon: 'error' });
                  });
            
            } catch (error)
            {
                  SweetAlert.fire({
                    title: 'Error ocured while getting warranties or avalistes',
                    icon: 'error',
                  }); 
              }
            }
            }
          );
                
        }
        
}



 const columns: ColumnsType<any> = [
  {
      title: 'Date Demande',
      dataIndex: 'DateDemande',
  },
  {
      title: 'Agence',
      dataIndex: 'CODAGE',
    },
   {
      title: 'N° Demande',
      dataIndex: 'NumeroDemande',
    },
     {
      title: 'N° Client',
      dataIndex: 'Numcli',
    },
    {
      title: 'Nom Client',
      dataIndex: 'NOMCLI',
    },
    {
      title: 'Type de Qard',
      dataIndex: 'CodeQard',
    },
    {
      title: 'Code Gestionnaire',
      dataIndex: 'CODGEA',
    },
    {
      title: 'Montant Validé',
      dataIndex: 'MontantValide',
    },
    {
      title: 'Motif Demande',
      dataIndex: 'MOTIFDEM',
    }
  ];

    

const onSelectChange = (newSelectedRowKeys: any) => {

    console.log('selectedRowKeys changed: ', data[newSelectedRowKeys]);
    form.setFieldsValue(data[newSelectedRowKeys])
    handleDemandePret()

    setSelectedRowKeys(newSelectedRowKeys);
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  
    function handleDemandePret() {
  
      localStorage.setItem(Data.LocalVariable.reset, "1")
      //let searchPret:Params={CodeAgence:'',Table: "CPRETS",Colonne1:"",Colonne2:"",Colagence:'101', Init: form.getFieldValue("NUMDOS"), Choix:3}
      let data = Crypter.encrypt(form.getFieldValue("NumeroDemande"));
      let numdos = form.getFieldValue("NumeroDemande")
      let dataction = Crypter.encrypt('READ_DEMANDE');
  
      if (data.length != 0) {
        // form.setFieldValue('garantie', '')
        // form.setFieldValue('avaliste', '')
        initialiazeButton()
        setLoading(true)
        form.resetFields()
        form.setFieldValue('NumeroDemande', numdos)
        let config = {
          method: 'get',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.ReadFiancementQard,
          headers: {
            'CypherNumeroDemandeQard': data,
            'CypherAction': dataction,
            'Authorization': authHeader(),
            'Content-Type': 'application/json'
          },
        };
        axios.request(config)
          .then((response) => {
            setLoading(false);
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;
  
              console.log(res);
              
              if (res.StatutCode == 200) 
              {
                form.setFieldsValue(res.Result.Table1[0]);
                form.setFieldValue('DatePremEch', ReformatDate(res.Result.Table1[0].DatePremEch));
                form.setFieldValue('DateDemande', ReformatDate(res.Result.Table1[0].DateDemande));
                form.setFieldValue('lib_NUMCLI',res.Result.Table1[0].NOMCLI);
                form.setFieldValue('MontantValide',res.Result.Table1[0].MontantValide);
                   
              //form.setFieldValue('', )
              const garantiesRetournees: DataTypeTable[] = [];
              var newData:any =  [];
              if(res.Result.Table2)
              {
                 // garantiesRetournees= res.Result.Table2.map((data:any,index:number)=>
                //   ({...data, valCouvert:data.montantcouvert}));
                 let montantGarantieCouvert=0;
                  
                res.Result.Table2.map((data:any,index:number)=>{
                  montantGarantieCouvert+=data.MontantCouvert;
                  garantiesRetournees.push({ ...data, 
                    valCouvert:data.MontantCouvert
                  })
                })
                 form.setFieldValue('montantGarantieCouvert',montantGarantieCouvert);
              }
  
                if(res.Result.Table3)
              {
                 // garantiesRetournees= res.Result.Table2.map((data:any,index:number)=>
                //   ({...data, valCouvert:data.montantcouvert}));
                res.Result.Table3.map((data:any,index:number)=>{newData.push({ 
                  ...data,
                    CapitalRembourse:formatNumber(data.CapitalRembourse),
                  CapitalRestant:formatNumber(data.CapitalRestant),
                  DateEcheance:    data.DateEcheance ? (new Date(data.DateEcheance.substring(0, 10))).toLocaleDateString("fr") : ''
                })})
                 setdatatabamort(newData);
              }

              setDocuments(res.Result.Table4 || []);
                //  alert(JSON.stringify(res.Result.Table4))
  
                setGarantiesTableau(garantiesRetournees);
                setdatatabamort(newData as any)
                consultTypecard();
                initialiazeButton();
                cunsultButton();  
                setEnregActve(true) 
                setImpActive(false);
             
              }
              else {
                localStorage.removeItem(Data.LocalVariable.reset)
                SweetAlert.fire({ title: res.Message, icon: "warning" })
                setSelectedRowKeys([])
              }
            }
            setLoading(false)
          })
          .catch((error) => {
            localStorage.removeItem(Data.LocalVariable.reset)
            setLoading(false);
            console.log(error)
            SweetAlert.fire({ title: error, icon: "error" })
            setSelectedRowKeys([])
          });
      }
    }


    function consultTypecard() 
    {
        if (form.getFieldValue('CodeQard') == null) {
          SweetAlert.fire({ title: 'Svp renseigner le Code du type de Qard ', icon: 'warning' });
        } else {
          let data = form.getFieldValue('CodeQard');
          if (data.length != 0) {
            setLoading(true);
            let config = {
              method: 'get',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.ReadParamsQard,
              headers: {
                CypherCodeQard: Crypter.encrypt(data),
                Authorization: authHeader(),
                'Content-Type': 'application/json',
              },
            };
    
            axios
              .request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
    
                  if (res.StatutCode == 200) {
                    let paramsQardData: ParamsQard = res.Result.Table[0];
                    // const frais = res.Result.Table1.reduce(
                    //   (total: number, x: any) => total + Number(x.MONFIX || 0),
                    //   0
                    // );
    
                    paramsQardData.Frais = res.Result.Table1.map((x: any) => x.CODOPE);
    
                    form.setFieldValue('CodeFrais', paramsQardData.Frais);
                    // form.setFieldValue('FraisService', frais);
                  } else {
                    SweetAlert.fire({ title: 'Warning', text: res.Message, icon: 'warning' });
                  }
                }
                setLoading(false);
              })
              .catch((error) => {
                setLoading(false);
                console.log(error);
                SweetAlert.fire({ title: 'Error', text: error, icon: 'error' });
              });
          }
        }
   }

  const onFinishFailed = async (errorInfo: any) => {
       var errors: any = [];
       errorInfo.errorFields.map((error: any) => {
         errors.push(error.name + '');
       });
       SweetAlert.fire({
         title: 'Veuillez remplir tous les champs obligatoires',
         text: errors.toString().replaceAll(',', ' - '),
         icon: 'warning',
         confirmButtonText: 'OK',
       });
     };
 

  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>CONTRAT DE FINANCEMENT ISLAMIQUE</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form preserve onFinish={onFinish}    onFinishFailed={onFinishFailed}  disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={modifActve} onClick={modifButton} type="ghost" htmlType="button" block  >
                  Modifier
                </Button>
                <Button size='large' className='bt_add' onSubmit={onFinish} disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>
                <Button size='large' className='bt_add'  onClick={() => { setSbmit('Apercu');}}  disabled={impActive}  htmlType="submit" type="ghost" block>
                  Aperçu 
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div>
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
              <Box display={"flex"} fontStyle="inherit" className='border-left tabElementValFin'>
                <Spin spinning={loading}>
                  <Form disabled={radioaCheck}>
                    <Table size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", }} columns={columns} dataSource={data} scroll={{ y: 190, x: 10 }} pagination={false} />
                  </Form>
                </Spin>
              </Box>
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default Contratfinancement;